import "./Articlebanner.css";

function ArticlebannerLoading() {
  return (
    <>
      <section id="article-banner">
        <div className="shimmer-dark article-banner-cover" />
      </section>
      <div className="article-meta-skeleton">
        <div className="shimmer article-skeleton-title" />
        <div className="shimmer article-skeleton-intro-line" style={{ width: "560px" }} />
        <div className="shimmer article-skeleton-intro-line" style={{ width: "420px" }} />
        <div className="shimmer article-skeleton-date" style={{ marginTop: "8px" }} />
        <div className="shimmer article-skeleton-date" />
      </div>
    </>
  );
}

export default ArticlebannerLoading;
